import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { BASE_URL } from './Constants';
import { userLogout } from '../app/reducers/userInfo/slice';

export const baseQueryWithAuth = async (args, api, extraOptions) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers, { getState, endpoint }) => {
      // Bypass token for login endpoint
      if (endpoint === 'loginUser') {
        return headers;
      }
      // Get the token from the Redux store
      const accessToken = getState().userInfo.user?.token;
      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }
      return headers;
    },
  });

  const result = await baseQuery(args, api, extraOptions);

  // Check for 401 status and dispatch logout
  if (result.error && result.error.status === 401) {
    api.dispatch(userLogout());
  }

  return result;
};
